var irreducible = require('./irreducible');
var isNumber = require('./isNumber');

module.exports = irreducible('Number', isNumber);



/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form-templates-bootstrap/~/tcomb/lib/Number.js
 ** module id = 85
 ** module chunks = 0
 **/